
    const data = {"name":"src/core/icons/file-delimited-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m4 18H6V4h7v5h5v11m-8-1 2-4H9v-5h6v5l-2 4h-3\"/>","originalColors":[],"stopColors":[]}}

            export default data
            